module.exports = __webpack_public_path__ + "static/media/IMG_9038.725b6845.JPG";